module.exports = __webpack_public_path__ + "img/shipo-menu-unloading-checklist-white.b53fab26.svg";